export default "__VITE_ASSET__Clotuy1W__"